module.exports = __webpack_public_path__ + "img/USDCHF.7b8a1e3e.png";